import { useGetSystemSettingsQuery } from '@shared/services/systemSettings';

export const useSystemSettingsValue = (categories: string[], skip = false) => {
  const { data: systemSettings, isFetching } = useGetSystemSettingsQuery(
    {
      Categories: categories,
    },
    { skip }
  );

  const getValue = (category: string): string | undefined =>
    systemSettings?.find((s) => s.Category === category)?.Value;

  return { getValue, isFetching };
};
